import script from "./Changelog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Changelog.vue?vue&type=script&setup=true&lang=ts"

import "./Changelog.vue?vue&type=style&index=0&id=b058581a&lang=scss"

const __exports__ = script;

export default __exports__